/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Surcharge/view.blocks to change it.
import React from 'react'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Surcharge({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation/PlatformFeeWarning/Content/AcknowledgementText/Card/Surcharge",
  text
  
}) {
  return (<React.Fragment
>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text={text}
/>
{children}
</React.Fragment>)
}